// @ts-nocheck
/* eslint-disable */
import ScenePixel from "~/scene/common/pixel";
import SceneConst from "~/scene/common/const";
import SceneCoords from "~/scene/common/coords";
import { store } from "~/state/store";

/**
 * Abeceda pro sifrovani souradnic.
 *
 * @type {String}
 */
const ALPHABET = "0ABCD2EFGH4IJKLMN6OPQRST8UVWXYZ-1abcd3efgh5ijklmn7opqrst9uvwxyz.";

export default class SceneCoordsInterface {
	constructor() {
		this._availability = { /* cachovane info o dostupnosti */
			ophoto: {},
		};
	}

	/**
	 * Tovární metoda - výroba souřadnic z WGS 84
	 *
	 * @param {Number} lonD Longitude (zeměpisná délka) ve stupních jako desetinné číslo nebo řetězec
	 * @param {Number} latD Latitude (zeměpisná šířka) ve stupních jako desetinné číslo nebo řetězec
	 * @returns {SceneCoords}
	 */
	coordsFromWGS84(lonD ,latD) {
		if (arguments.length == 1) {
			let pair = this._splitWGS84(arguments[0]);
			lonD = pair[0];
			latD = pair[1];
		}

		if (typeof(lonD) == "string") { lonD = this._fromWGS84str(lonD); }
		if (typeof(latD) == "string") { latD = this._fromWGS84str(latD); }

		return new SceneCoords(this, lonD, latD);
	}

	/**
	 * Tovární metoda - výroba souřadnic z PP
	 *
	 * @param {Number} PPx Xová souřadnice
	 * @param {Number} PPy Yová souřadnice
	 * @returns {SceneCoords}
	 */
	coordsFromPP(PPx, PPy) {
		let coords = SMap.proj4.transform(SMap.proj4.PROJECTIONS.PP, SMap.proj4.PROJECTIONS.WGS84, [PPx, PPy]);

		return new SceneCoords(this, coords[0], coords[1]);
	}

	/**
	 * Tovární metoda - výroba souřadnic z UTM33
	 *
	 * @param {Number} x Xová souřadnice
	 * @param {Number} y Yová souřadnice
	 * @returns {SceneCoords}
	 */
	coordsFromUTM33(x, y) {
		let coords = SMap.proj4.transform(SMap.proj4.PROJECTIONS.UTM(33), SMap.proj4.PROJECTIONS.WGS84, [x, y]);

		return new SceneCoords(this, coords[0], coords[1]);
	}

	/**
	 * Tovární metoda - výroba souřadnic z Mercator metrů (epsg:3857)
	 *
	 * @param {Number} x Xová souřadnice
	 * @param {Number} y Yová souřadnice
	 * @returns {SceneCoords}
	 */
	coordsFromMercator(x, y) {
		let coords = SMap.proj4.transform(SMap.proj4.PROJECTIONS.MERCATOR, SMap.proj4.PROJECTIONS.WGS84, [x, y]);

		return new SceneCoords(this, coords[0], coords[1]);
	}

	/**
	 * Tovární metoda - výroba souřadnic z (S-)JTSK.
	 *
	 * @param {Float} x
	 * @param {Float} y
	 */
	coordsFromJTSK(x, y) {
		if (!(x && y)) { return this.coordsFromWGS84(0, 0); }

		let coords = SMap.proj4.transform(SMap.proj4.PROJECTIONS.JTSK, SMap.proj4.PROJECTIONS.WGS84, [x, y]);

		return new SceneCoords(this, coords[0], coords[1]);
	}

	/**
	 * Převod z OpenLocation formátu na SMap.Coords
	 *
	 * @param  {String} olc Řetězec s OLC kódem
	 * @returns {SceneCoords}
	 */
	coordsFromOLC(olc) {
		let coords = SMap.proj4.transform(SMap.proj4.PROJECTIONS.OLC, SMap.proj4.PROJECTIONS.WGS84, olc);

		return new SceneCoords(this, coords[0], coords[1]);
	}

	/**
	 * Převod z MGRS formátu na SMap.Coords
	 *
	 * @param  {String} mgrs Řetězec s MGRS kódem
	 * @returns {SceneCoords}
	 */
	coordsFromMGRS(mgrs) {
		let coords = SMap.proj4.transform(SMap.proj4.PROJECTIONS.MGRS, SMap.proj4.PROJECTIONS.WGS84, mgrs);

		return new SceneCoords(this, coords[0], coords[1]);
	}

	/**
	 * Vytvoreni souradnic z exifu.
	 *
	 * @param  {Object} exif Object s exif daty
	 * @return {SceneCoords}
	 */
	coordsFromEXIF(exif) {
		let tags = exif.getTags();

		let lon = tags.GPSLongitude;
		let lat = tags.GPSLatitude;
		if (!lat || !lon) { throw new Error("No GPS data in EXIF"); }

		let x = 0
		let y = 0;
		let divisor = 1;

		for (let i=0;i<3;i++) {
			x += lon[i] / divisor;
			y += lat[i] / divisor;
			divisor *= 60;
		}

		if (tags.GPSLongitudeRef && tags.GPSLongitudeRef.toUpperCase() == "W") { x = -x; }
		if (tags.GPSLatitudeRef && tags.GPSLatitudeRef.toUpperCase() == "S") { y = -y; }

		return this.coordsFromWGS84(x, y);
	}

	/**
	 * Převede souřadnice do UTM33
	 *
	 * @param {SceneCoords} coords Vstupni souradnice
	 * @returns {Float[]} Pole [x, y]
	 */
	coordsToUTM33(coords) {
		return SMap.proj4.transform(SMap.proj4.PROJECTIONS.WGS84, SMap.proj4.PROJECTIONS.UTM(33), [coords.x, coords.y]);
	}

	/**
	 * Převede souřadnice do WGS 84
	 *
	 * @param {SceneCoords} coords Vstupni souradnice
	 * @param {Number} [format] Formát pro převod na řetězec: čím větší číslo, tím detailnější je řetězec (0 = stupně, 1 = minuty, 2 = vteřiny). Při nezadání bude vrácena dvojice floatů.
	 * @returns {Float[] || String[]} Pole [longitude, latitude]
	 */
	coordsToWGS84(coords, format) {
		let result = [coords.x, coords.y];

		return (typeof(format) == "number" ? this._formatWGS84(result, format) : result);
	}

	/**
	 * Převede souřadnice do PP
	 *
	 * @param {SceneCoords} coords Vstupni souradnice
	 * @returns {Float[]} Pole [PPx, PPy]
	 */
	coordsToPP(coords) {
		return SMap.proj4.transform(SMap.proj4.PROJECTIONS.WGS84, SMap.proj4.PROJECTIONS.PP, [coords.x, coords.y]);
	}

	/**
	 * Převod do Mercator metrů (epsg:3857)
	 *
	 * @param {SceneCoords} coords Vstupni souradnice
	 * @returns {Float[]} Pole [x, y]
	 */
	coordsToMercator(coords) {
		return SMap.proj4.transform(SMap.proj4.PROJECTIONS.WGS84, SMap.proj4.PROJECTIONS.MERCATOR, [coords.x, coords.y]);
	}

	/**
	 * Převede souřadnice do (S-)JTSK.
	 *
	 * @param {SceneCoords} coords Vstupni souradnice
	 * @returns {Float[]} Pole [x, y]
	 */
	coordsToJTSK(coords) {
		return SMap.proj4.transform(SMap.proj4.PROJECTIONS.WGS84, SMap.proj4.PROJECTIONS.JTSK, [coords.x, coords.y]);
	}

	/**
	 * Převod do OpenLocation formátu.
	 *
	 * @param {SceneCoords} coords Vstupni souradnice
	 * @param  {Number} [codeLength] Délka výstupního kódu, která nezahrnuje oddělovací znaky
	 * @return {String}
	 */
	coordsToOLC(coords, codeLength) {
		return SMap.proj4.transform(SMap.proj4.PROJECTIONS.WGS84, SMap.proj4.PROJECTIONS.OLC(codeLength), [coords.x, coords.y]);
	}

	/**
	 * Převod do MGRS formátu.
	 *
	 * @param {SceneCoords} coords Vstupni souradnice
	 * @param  {int} [precision] Přesnost MGRS výstupního hashe
	 * @return {String}
	 */
	coordsToMGRS(coords, precision) {
		return SMap.proj4.transform(SMap.proj4.PROJECTIONS.WGS84, SMap.proj4.PROJECTIONS.MGRS(precision), [coords.x, coords.y]);
	}

	/**
	 * Spočte souřadnici takového pevného bodu, aby zoom okolo něj skončil se středem v zadaném bodě
	 *
	 * @param {SceneCoords} newCenter Střed
	 * @param {Number} newZoom Nový zoom
	 * @returns {ScenePixel} Nový pevný bod
	 */
	fixedPoint(newCenter, newZoom) {
		const { zoom } = store.getState().map;
		let distanceScale = Math.pow(2, newZoom - zoom);

		return this.coordsToPixel(newCenter, newZoom).scale(1 / (distanceScale - 1));
	}

	/**
	 * Zakodovani souradnic do retezce.
	 *
	 * @param  {Array[SceneCoords]} coords Vstupni souradnice
	 * @return {String}
	 */
	coordsToString(coords) {
		let ox = 0;
		let oy = 0;
		let result = "";

		coords.forEach(item => {
			let coords = item.toWGS84();
			let x = Math.round((coords[0] + 180) * (1 << 28) / 360);
			let y = Math.round((coords[1] + 90) * (1 << 28) / 180);

			let dx = x - ox;
			let dy = y - oy;
			/*if (!dx && !dy) { continue; }*/

			result += this._serializeNumber(dx, x);
			result += this._serializeNumber(dy, y );

			ox = x;
			oy = y;
		});

		return result;
	}

	/**
	 * Reverzni proces pro desifrovani retezce na pole souradnic.
	 *
	 * @param  {String} str Vstupni retezec
	 * @return {Array[SceneCoords]} coords Vystupni souradnice
	 */
	stringToCoords(str): Array<SceneCoords> {
		let FIVE_CHARS = (1+2) << 4;
		let THREE_CHARS = 1 << 5;

		let results = [];
		let coords = [0, 0];
		let coordIndex = 0;
		let arr = str.trim().split("").reverse();

		while (arr.length) {
			let num = this._parseNumber(arr, 1); /* podle prvnich dvou bitu poznam, o co jde */

			if ((num & FIVE_CHARS) == FIVE_CHARS) { /* cela souradnice */
				num -= FIVE_CHARS;
				num = ((num & 0xF) << 24) + this._parseNumber(arr, 4);
				coords[coordIndex] = num;
			} else if ((num & THREE_CHARS) == THREE_CHARS) { /* velky posun - 16 bitu */
				num = ((num & 0xF) << 12) + this._parseNumber(arr, 2);
				num -= (1 << 15);
				coords[coordIndex] += num;
			} else { /* maly posun - 11 bitu */
				num = ((num & 0x1F) << 6) + this._parseNumber(arr, 1);
				num -= (1 << 10);
				coords[coordIndex] += num;
			}

			if (coordIndex) { /* mame dvojici souradnic - sup s nima do floatu */
				let x = coords[0] * 360 / (1 << 28) - 180;
				let y = coords[1] * 180 / (1 << 28) - 90;

				results.push(new SceneCoords(this, x, y));
			}

			coordIndex = (coordIndex+1) % 2;
		}

		return results;
	}

	/**
	 * Reverzni proces pro desifrovani retezce na pole souradnic.
	 *
	 * @param  {String} str Vstupni retezec
	 * @return {Array[string]} coords Vystupni souradnice ve wgs84
	 */
	stringToWGS84(str) {
		let FIVE_CHARS = (1+2) << 4;
		let THREE_CHARS = 1 << 5;

		let results = [];
		let coords = [0, 0];
		let coordIndex = 0;
		let arr = str.trim().split("").reverse();

		while (arr.length) {
			let num = this._parseNumber(arr, 1); /* podle prvnich dvou bitu poznam, o co jde */

			if ((num & FIVE_CHARS) == FIVE_CHARS) { /* cela souradnice */
				num -= FIVE_CHARS;
				num = ((num & 0xF) << 24) + this._parseNumber(arr, 4);
				coords[coordIndex] = num;
			} else if ((num & THREE_CHARS) == THREE_CHARS) { /* velky posun - 16 bitu */
				num = ((num & 0xF) << 12) + this._parseNumber(arr, 2);
				num -= (1 << 15);
				coords[coordIndex] += num;
			} else { /* maly posun - 11 bitu */
				num = ((num & 0x1F) << 6) + this._parseNumber(arr, 1);
				num -= (1 << 10);
				coords[coordIndex] += num;
			}

			if (coordIndex) { /* mame dvojici souradnic - sup s nima do floatu */
				let x = coords[0] * 360 / (1 << 28) - 180;
				let y = coords[1] * 180 / (1 << 28) - 90;

				results.push([x, y]);
			}

			coordIndex = (coordIndex+1) % 2;
		}

		return results;
	}

	/**
	 * Prevod retezce na pole vysek.
	 *
	 * @param  {String} str Vstupni retezec
	 * @return {Array[Number]}
	 */
	stringToAltitude(str) {
		let results = [];
		let e0 = 0;
		let arr = str.trim().split("").reverse();
		let c1, c2, c3;
		let d1, d2, d3;

		let decNonZeroDelta = function(c, m) {
			return c - m + (c >= m ? 1 : 0);
		}

		while (arr.length) {
			c1 = this._parseNumber(arr, 1); /* podle prvnich dvou bitu poznam, o co jde */

			if ((c1 & 0x20) == 0x00) {
				let n = 1 + ((c1 & 0x18) >> 3);
				d1 = (c1 & 0x07) - 3;
				for (let i=0;i<n;i++) { results.push(e0); }
				if (d1 != 4) {
					e0 += d1;
					results.push(e0);
				}
			} else if ((c1 & 0x30) == 0x20) {
				d1 = decNonZeroDelta((c1 & 0x0F), 8);
				e0 += d1;
				results.push(e0);
			} else if ((c1 & 0x38) == 0x30) {
				c2 = this._parseNumber(arr, 1);
				d1 = decNonZeroDelta((c1 & 0x07), 4);
				d2 = decNonZeroDelta((c2 >> 3), 4);
				d3 = (c2 & 0x07) - (d2 < 0 ? 4 : 3);
				e0 += d1;
				results.push(e0);
				e0 += d2;
				results.push(e0);
				e0 += d3;
				results.push(e0);
			} else if ((c1 & 0x3C) == 0x38) {
				c2 = this._parseNumber(arr, 1);
				d1 = (c1 & 0x03) << 6;
				d2 = (c2 & 0x3F) - 128;
				e0 += d1 + d2;
				results.push(e0);
			} else {
				c2 = this._parseNumber(arr, 1);
				c3 = this._parseNumber(arr, 1);
				d1 = (c1 & 0x03) << 12;
				d2 = (c2 & 0x3F) << 6;
				d3 = (c3 & 0x3F) - 8192;
				e0 += d1 + d2 + d3;
				results.push(e0);
			}
		}

		return results;
	}

	/**
	 * Je souradnice videt na mape?
	 *
	 * @param {SceneCoords} coords Testovaci souradnice
	 * @param {Boolean|Object} padding Pouzit padding - zmensit viewport sceny? True = padding aktualniho providera nebo { top: 0, left: 0... }
	 * @return {Boolean}
	 */
	coordsInMap(coords, padding) {
		let rb = this.getSize().clone().scale(0.5);
		let lt = rb.clone().scale(-1);

		if (padding) {
			let paddingObj = typeof padding === "boolean" ? store.getState().map.padding : padding;

			lt.x += paddingObj.left;
			lt.y += paddingObj.top;
			rb.y -= paddingObj.bottom;
			rb.x -= paddingObj.right;
		}

		let px = this.coordsToPixel(coords);

		return (px.x >= lt.x && px.x <= rb.x && px.y >= lt.y && px.y <= rb.y);
	}

	/**
	 * Je na zadanych souradnicich dostupny letecky snimek?
	 *
	 * @param  {SceneCoords}  coords Vstupni souradnice
	 * @return {Boolean}
	 */
	isOphotoAvailable(coords) {
		const { longitude, latitude } = store.getState().map;
		let c = (coords || this.coordsFromWGS84(longitude, latitude)).toWGS84();
		let key = c.join("-");

		if (!(key in this._availability.ophoto)) {
			this._availability.ophoto[key] = false;

			let extents = SceneConst.ophotoExtents || [];

			for (let i = 0; i < extents.length; i++) {
				if (this.pointInPolygon(c, extents[i])) {
					this._availability.ophoto[key] = true;
					break;
				}
			}
		}

		return this._availability.ophoto[key];
	}

	/**
	 * Test, jestli se bod nachazi uvnitr polygonu.
	 *
	 * @param  {Array[Number,Number]} point Vstupni bod
	 * @param  {Array[[Number,Number],...]} polygon Polygon definovany 0..n body
	 * @return {Boolean}
	 */
	pointInPolygon(point, polygon) {
		let crossings = 0;

		for (let i = 0; i < polygon.length; i++) {
			let p1 = polygon[i ? i-1 : polygon.length-1];
			let p2 = polygon[i];

			if (
				(p1[1] <= point[1] && p2[1] > point[1])    // an upward crossing
				|| (p1[1] > point[1] && p2[1] <= point[1]) // a downward crossing
			) { // compute the actual edge-ray intersect x-coordinate
				let vt = (point[1] - p1[1]) / (p2[1] - p1[1]);

				if (point[0] < p1[0] + vt * (p2[0] - p1[0])) { crossings++; } // point[0] < intersect
			}
		}

		return (crossings & 1);
	}

	/**
	 * Test, jestli se pixel nachazi uvnitr polygonu.
	 *
	 * @param  {ScenePixel} pixel Vstupni pixel
	 * @param  {Array[[Number,Number],...]} polygon Polygon definovany 0..n body
	 * @return {Boolean}
	 */
	pixelInPolygon(pixel, polygon) {
		return this.pointInPolygon([pixel.x, pixel.y], polygon);
	}

	/**
	 * Ziskani rozmeru pixelu.
	 *
	 * @return {Number}
	 */
	getPixelSize() {
		const { longitude, latitude } = store.getState().map;
		let x = 1;
		let y = 0;

		if (this._active == this._providers.m3d) {
			let size = this.getSize();

			x = Math.round(size.x / 2);
			y = Math.round(size.y / 2);
		}

		return this.pixelToCoords(new ScenePixel(x, y)).distance(this.coordsFromWGS84(longitude, latitude));
	}

	/**
	 * Serializace cisla.
	 *
	 * @param {Number} delta
	 * @param {Number} orig
	 * @private
	 */
	_serializeNumber(delta, orig) {
		let code = "";

		if (delta >= -1024 && delta < 1024) {
			code += ALPHABET.charAt((delta + 1024) >> 6);
			code += ALPHABET.charAt((delta + 1024) & 63);
		}
		else if (delta >= -32768 && delta < 32768) {
			let value = 0x20000 | (delta + 32768);
			code += ALPHABET.charAt((value >> 12) & 63);
			code += ALPHABET.charAt((value >>  6) & 63);
			code += ALPHABET.charAt(value & 63);
		}
		else {
			let value = 0x30000000 | (orig & 0xFFFFFFF);
			code += ALPHABET.charAt((value >> 24) & 63);
			code += ALPHABET.charAt((value >> 18) & 63);
			code += ALPHABET.charAt((value >> 12) & 63);
			code += ALPHABET.charAt((value >>  6) & 63);
			code += ALPHABET.charAt(value & 63);
		}

		return code;
	}

	/**
	 * Parsovani cisla.
	 *
	 * @param {Array} arr
	 * @param {Number} count
	 * @private
	 */
	_parseNumber(arr, count) {
		let result = 0;
		let i=count;

		while (i) {
			if (!arr.length) { throw new Error("No data!"); }
			let ch = arr.pop();
			let index = ALPHABET.indexOf(ch);
			if (index == -1) { continue; }
			result <<= 6;
			result += index;
			i--;
		}

		return result;
	}

	/**
	 * Rozdělí řetězec souřadnic na dva podřetězce
	 *
	 * @param {string} str Souřadnice
	 * @returns {string[]} [lonS, latS] - zeměpisná délka a šířka ve dvou řetězcích
	 */
	_splitWGS84(str) {
		let parts = str.match(/[nsew]|[^nsew]+/gi);
		if (parts.length != 4) { throw new Error("Not a valid WGS84 string."); }

		let two = [parts.slice(0, 2).join(""), parts.slice(2).join("")];
		if (two[0].match(/[ns]/i)) { two.reverse(); }

		return two;
	}

	/**
	 * Převede (jednu) souřadnici z řetězce na desetinné číslo ve stupních
	 *
	 * @param {string} str Souřadnice
	 * @returns {float} Souřadnice
	 */
	_fromWGS84str(str) {
		let result = 0;
		let wgs_re = /-?\d+([.,]\d*)?/g;
		let lo_re = /[ws] *$/gi;

		let parts = str.match(wgs_re);
		if (!parts) { return result; }

		let exp = 1;
		for (let i=0; i<parts.length; i++){
			let num = parts[i].replace(/,/g, ".");
			result += parseFloat(num)/exp;
			exp *= 60;
		}

		if (str.match(lo_re)) { result *= -1; }
		return result;
	}

	/**
	 * Formátování WGS84 hodnot (desetinných čísel) na řetězce
	 *
	 * @param {Float[]} input
	 * @param {Number} format
	 */
	_formatWGS84(input, format) {
		let max = Math.min(format, 2);
		let output = [];
		let precision = 1000;
		let chars = ["°", "'", '"'];
		let suffixes = [
			["E", "W"],
			["N", "S"]
		];

		for (let i=0;i<input.length;i++) {
			let divisor = 3600 * precision;
			let value = Math.round(divisor * Math.abs(input[i]));
			let str = "";

			for (let j=0;j<=max; j++) {
				let part = value / divisor;
				if (j < max) {
					part = Math.floor(part);
					value = value % divisor;
				} else {
					part = part.toFixed(7-2*max);
				}

				divisor /= 60;
				str += part;
				str += chars[j];
			}

			str += (input[i] > 0 ? suffixes[i][0] : suffixes[i][1]);
			output.push(str);
		}

		return output;
	}
}
